import React from 'react';
import NewsCard from './NewsCard';
import { useLanguage } from '../context/LanguageContext';

const NewsSection = () => {
  const { t } = useLanguage();
  const newsItems = t('news.items') || [];
  // newsItems fetched from translations

  return (
    <section id="news" className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 fade-in">
          <h2 className="text-3xl font-normal text-gray-800 mb-4">{t('news.sectionTitle')}</h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {newsItems.map((news, index) => (
            <NewsCard
              key={index}
              title={news.title}
              description={news.description}
              imageText={news.imageText}
              date={news.date}
              category={news.category}
            />
          ))}
        </div>

        <div className="text-center mt-12 fade-in">
        </div>
      </div>
    </section>
  );
};

export default NewsSection;